import { render, staticRenderFns } from "./PedigreeDefinitionTable.vue?vue&type=template&id=b323c8ba&"
import script from "./PedigreeDefinitionTable.vue?vue&type=script&lang=js&"
export * from "./PedigreeDefinitionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports